/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";
interface Signature {
  Element: HTMLDivElement;
  Args: {
    setVaccinationDateProperty?: unknown;
    setDoneProperty?: unknown;
    changeset?: unknown;
    shouldShowDateLabel?: unknown;
    comorbiditiesChangeset?: unknown;
    patient: Patient;
    forcComponent: unknown;
  };
}
export default class extends Component<Signature> {
  titleStyle = "pt-[1em]";
}
